/**
 * @voltxampere/web — Circuit signal (Sprint 11 placeholder).
 *
 * Sprint 12 will wire this to the canvas reducer; Sprint 13
 * will marshal it across the worker boundary. For Sprint 11
 * the signal exists so the topbar / statusbar can render a
 * "no circuit yet" state without conditional render guards
 * scattered through every consumer.
 *
 * Copyright © 2026 360 Studio
 * Proprietary — All rights reserved.
 */

import { signal } from "@preact/signals-core";
import type { Circuit } from "@voltxampere/schema";

export const currentCircuit = signal<Circuit | null>(null);
